import * as React from "react";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  LinearProgress,
  Paper,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  Tabs,
  Tab,
  Autocomplete,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import PaymentsIcon from "@mui/icons-material/Payments";
import DescriptionIcon from "@mui/icons-material/Description";
import TaskIcon from "@mui/icons-material/Task";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import UpdateIcon from "@mui/icons-material/Update";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AppTheme from "../../../../shared-theme/AppTheme";
import AppShellCobros from "../components/appshellcobros";
import Loans from "./loans";
import { LocationOnOutlined, PersonSearch, Search, Group} from "@mui/icons-material";
import { formatNumberWithCommas } from "../../../../utils/generalFunctions";
import ClienteScore from "../../../../components/ClienteScore";

const drawerWidth = 264;
const PRODUCT_NAME = "Diseño de Puntadas";

// Helper function to get relative time
function getRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  
  if (diffInSeconds < 60) {
    return 'hace unos segundos';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `hace ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
  } else if (diffInSeconds < 2592000) {
    const days = Math.floor(diffInSeconds / 86400);
    return `hace ${days} ${days === 1 ? 'día' : 'días'}`;
  } else if (diffInSeconds < 31536000) {
    const months = Math.floor(diffInSeconds / 2592000);
    return `hace ${months} ${months === 1 ? 'mes' : 'meses'}`;
  } else {
    const years = Math.floor(diffInSeconds / 31536000);
    return `hace ${years} ${years === 1 ? 'año' : 'años'}`;
  }
}

function LogoGlyph(props) {
  return (
    <SvgIcon viewBox="0 0 48 48" {...props}>
      <path d="M4 42.4379C4 42.4379 14.0962 36.0744 24 41.1692C35.0664 46.8624 44 42.2078 44 42.2078L44 7.01134C44 7.01134 35.068 11.6577 24.0031 5.96913C14.0971 0.876274 4 7.27094 4 7.27094L4 42.4379Z" />
    </SvgIcon>
  );
}

function StatCard({ label, value, color }) {
    
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5, color }}>
        {value}
      </Typography>
    </Paper>
  );
}

function DelinquencyBar({ label, value, color }) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="body2" color="text.secondary" sx={{ width: 56 }}>
        {label}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          flex: 1,
          height: 12,
          borderRadius: 999,
          "& .MuiLinearProgress-bar": { backgroundColor: color },
          backgroundColor: "#eef2f6",
        }}
      />
    </Stack>
  );
}

export default function ClientDashboard(props) {
  const [tabValue, setTabValue] = React.useState(0);
  const [clientes, setClientes] = React.useState([]);
  const [client, setClient] = React.useState(null);
  const [clientDetail, setClientDetail] = React.useState(null);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  React.useEffect(() => {

    const fetchClientes = async () => {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/clientes/${localStorage.getItem('idcompany')}`,{
        method: 'GET',  
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      const data = await response.json();
      setClientes(data);
    };
    fetchClientes();
    
  }, []);

  const fetchClient = async (id) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/clientes/detalle/${id}`,{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    const data = await response.json();
    //alert(parseFloat(data.prestamos[0].capitalPendiente)+1000);
    setClient(data);
    setClientDetail(data);
  };

  const handleClientChange = (val) => {
    if(val){
    fetchClient(val.id);
    }else{
      setClientDetail(null);
    }
  };

  return (
    <AppTheme {...props}>
      <AppShellCobros title="Bankivo · Centro de Cobros">
        {clientDetail ? (
        <Box sx={{ p: 2, mr: 5 }}>
          {/* Header with search and actions */}
          <Paper sx={{ p: 3, mb: 3, backgroundColor: "white" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              <Box>
                <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ color: "text.secondary", fontSize: 14 }}>
                  <Link underline="hover" color="inherit" href="#">
                    Clientes
                  </Link>
                  <Typography color="text.primary">{clientDetail.nombre}</Typography>
                </Breadcrumbs>
              </Box>

              <Stack direction="row" spacing={1}>
              <Autocomplete
                sx={{width:400}}
                options={clientes}
                getOptionLabel={(option) => JSON.parse(option.campos)?.["1"]+" - "+option.identificacion}
                renderInput={(params) => 
                    <TextField 
                    {...params} 
                    placeholder="Buscar un cliente..." 
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search color="action" />
                          </InputAdornment>
                        ),
                      }}                          />

                }
                onChange={(e, val) => {handleClientChange(val)}}
                value={clientDetail}
                fullWidth
              />    
              </Stack>
            </Stack>

            {/* Hero / Client header */}
            <Stack spacing={2} direction={{ xs: "column", sm: "row" }} alignItems={{ sm: "center" }}>
              <Avatar
                sx={{ width: 88, height: 88 }}
              />
              <Box sx={{ flex: 1 }}>
                <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
                  <Typography variant="h5" fontWeight={800}>
                    {clientDetail.nombre}
                  </Typography>
                  <Chip label="Activo" size="small" color="success" variant="soft" />
                </Stack>
                <Typography variant="body2" color="text.secondary" textAlign={"left"} sx={{ mt: 0.5 }}>
                  ID de Cliente: {clientDetail.identificacion}
                </Typography>
{/*                <Stack direction="row" spacing={1} sx={{ mt: 1.5 }} flexWrap="wrap">
                  <Chip label="Alto Valor" size="small" />
                  <Chip label="Preferido" size="small" />
                  <Chip label="VIP" size="small" />
                </Stack>*/}
              </Box>
            </Stack>
                      </Paper>

            {tabValue === 0 && (
            <Grid container spacing={3}>
              {/* Tab Content */}
              {tabValue === 0 && (
                <>
                  {/* Left column - Overview */}
                  <Grid item size={8}>
                    {/* Overview KPIs */}
                    <Paper sx={{ p: 3, mb: 3, backgroundColor: "white" }}>
                      <Typography variant="h5" textAlign={"left"} fontWeight={800} sx={{ mb: 2 }}>
                        Resumen
                      </Typography>
                      <Grid container spacing={2} justifyContent={"center"}>
                        <Grid item size={2.4}>
                          <StatCard 
                            label="Saldo Total" 
                            value={
                              formatNumberWithCommas(
                              clientDetail.prestamos
                                .map(prestamo => {return Number(prestamo.capitalPendiente) + Number(prestamo.interesPendiente)})
                                .reduce((acc, val) => acc + val, 0).toFixed(2)
                              )
                            } 
                          />
                        </Grid>
                        <Grid item size={2.4}>
                          <StatCard label="Mora Actual" value={`${formatNumberWithCommas(clientDetail.mora_buckets.total_delinquent_amount)}`} color="#d32f2f" />
                        </Grid>
                        <Grid item size={2.4}>
                          <StatCard label="Ult. Fecha de Pago" value={`${clientDetail.pagos.length > 0 ? clientDetail.pagos[0].fecha_pago : 'N/A'}`} />
                        </Grid>
                        <Grid item size={2.4}>
                          <StatCard label="Prestamos Abiertos" value={`${clientDetail.prestamos.length}`} />
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* Charts */}
                    <Grid container spacing={3}>
                      <Grid item size={12}>
                        <Loans prestamos={clientDetail.prestamos}/>
                      </Grid>
                    </Grid>

                  </Grid>
                </>
              )}


            {/* Right column */}
            <Grid item size={4}>
              <Stack spacing={3}>

                {/* Score Component */}
                {clientDetail.scoring && (
                  <ClienteScore scoring={clientDetail.scoring} />
                )}

                <Paper sx={{ p: 3, backgroundColor: "white" }}>
                  <Typography variant="h6" fontWeight={800} sx={{ mb: 2 }}>
                    Información de Contacto
                  </Typography>
                  <Stack spacing={1.5}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <PhoneIcon color="action" />
                      <Typography>{JSON.parse(clientDetail.campos)["1753886767728"]}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <LocationOnOutlined color="action" />
                      <Typography>{JSON.parse(clientDetail.campos)["6"]}</Typography>
                    </Stack>
                  </Stack>
                </Paper>

                <Paper sx={{ p: 3, backgroundColor: "white" }}>
                  <Typography variant="h6" fontWeight={800} sx={{ mb: 2 }}>
                    Detalles de Relación
                  </Typography>
                  <Stack spacing={1.5}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <PersonIcon color="action" />
                      <Typography>{clientDetail.relacion.oficial}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <BusinessIcon color="action" />
                      <Typography>{clientDetail.relacion.sucursal}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <CalendarTodayIcon color="action" />
                      <Typography>Creado el: {clientDetail.relacion.creado_el}</Typography>
                    </Stack>
                  </Stack>
                </Paper>

              </Stack>
            </Grid>
            </Grid>
            )}
            {tabValue === 1 && (
              <Grid item size={12}>
                <Loans prestamos={clientDetail.prestamos}/>
              </Grid>
            )}
        </Box>
        ):

            <Box
                sx={{
                    minHeight: "80dvh",
                    bgcolor: "#f8fafc",
                    color: "#1f2937",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                }}
                >
                <Box sx={{ width: "100%", maxWidth: 560 }}>
                    <Paper
                        elevation={1}
                        sx={{
                            p: 4,
                            textAlign: "center",
                            border: "1px dashed",
                            borderColor: "divider",
                            borderRadius: 3,
                        }}
                    >
                    <Box
                        sx={{
                        width: 80,
                        height: 80,
                        mx: "auto",
                        mb: 3,
                        borderRadius: "50%",
                        bgcolor: "#dbeafe",
                        color: "#1976d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        }}
                    >
                        <PersonSearch sx={{ fontSize: 48 }} />
                    </Box>

                    <Typography variant="h5" fontWeight={700} gutterBottom>
                        No Hay Cliente Seleccionado
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Por favor selecciona un cliente para ver su información detallada.
                    </Typography>

                    <Box sx={{ width: "100%", maxWidth: 420, mx: "auto" }}>
                        <Autocomplete
                        fullWidth
                        options={clientes}
                        getOptionLabel={(option) => JSON.parse(option.campos)?.["1"]+" - "+option.identificacion}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            placeholder="Buscar un cliente..." 
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Search color="action" />
                                  </InputAdornment>
                                ),
                              }}                          />
                        )}
                        onChange={(e, val) => {handleClientChange(val)}}
                        value={clientDetail}
                        size="medium"
                        />

                        <Box
                        sx={{ my: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}
                        >
                        <Divider sx={{ flex: 1 }} />
                       
                        </Box>

                       
                    </Box>
                    </Paper>
                </Box>
                </Box>
           
    }
      </AppShellCobros>
    </AppTheme>
  );
}

// Small icon alias for "badge" to avoid extra import if preferred
function BadgeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 2H4v20l8-3 8 3V2zm-2 15.17l-6-2.25-6 2.25V4h12v13.17zM12 5a3 3 0 100 6 3 3 0 000-6z" />
    </SvgIcon>
  );
}
